<template>
  <div class="row">
    <LoaderMaskComponent v-if="lyLoading" />
    <div v-else class="col_12">
      <div class="d_flex_btwn">
        <h1 class="common_title">{{ group.name }}</h1>
        <span>
          <router-link :to="{name: 'groups'}" class="btn btn_black">Back to List</router-link>
        </span>
      </div>
      <div class="card border_none">
        <div class="card_body pl_0 pr_0">
          <div class="row">
            <div class="col_12">
              <nav class="tabs">
                <ul>
                  <li href="#tab4" :class="{active : activeTab === 'userList'}" @click="activeTab = 'userList'"> Users </li>
                </ul>
              </nav>
              <div class="tab_content_wrapper pl_0 pr_0 border_none">
                <div id="tab4" class="tab_content" :class="{show : activeTab === 'userList'}">
                  <div class="fadein">
                    <div class="account_content">
                      <div class="d_flex_btwn">
                        <div class="form_row">
                            <div class="form_input">
                              <div class="search_input mr_5">
                                <input type="text" class="form_global width_260p" placeholder="Search" v-model="queryParams.search">
                              </div>
                            </div>
                        </div>
                        <span>
                          <button type="button" class="btn btn_black" @click="openAddUserModal()">Add user</button>
                        </span>
                      </div>
                      <table-component
                        :columns="columns"
                        :rows="users"
                        :sortable="sortable"
                        :pagination="pagination"
                        @sorting="sorting"
                        @pageChanged="pageChanged">

                        <template v-slot:action="{ row }">
                            <router-link :to="`/user/${row.id}`" class="cursor_pointer" title="Edit user">
                              <img src="@/assets/media/images/edit.png" alt="">
                            </router-link>
                            <span class="pl_15 cursor_pointer" @click.prevent="removeRecord(row.id)" title="Remove user from group">
                              <img src="@/assets/media/images/trash.png" alt="">
                            </span>
                        </template>
                      </table-component>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <AddUserModal 
        v-if="showAddUserModal" 
        :showAddUserModal="showAddUserModal"
        :groupId="$route.params.id"
        @closeModal="closeAddUserModal"
      />
    </div>
  </div>
</template>

<script>
    import LoaderMaskComponent from "@/components/LoaderMaskComponent.vue";
    import TableComponent from "@/components/shared/TableComponent";
    import AddUserModal from './AddUserModal.vue';
    export default {
        name: 'group-view',
        components: {LoaderMaskComponent, TableComponent, AddUserModal},
        data(){
            return {
              lyLoading: false,
              group: null,
              activeTab: 'userList',
              users: [],
              sortable: {
                order: 'name',
                sort: 'desc'
              },
              queryParams: {
                page: 1,
                search: '',
                search_columns: 'name,email',
                sort: 'name',
                sort_order: 'desc',
                per_page: 10
              },
              columns: [
                {
                    label: "User Name",
                    field: "name",
                    sortable: true
                },
                {
                    label: "User Email",
                    field: 'email',
                    sortable: true,
                },
                {
                  label: "Last Login",
                  field: "last_login",
                  sortable: true
                },
                {
                    label: "Action",
                    field: 'action',
                    sortable: false,
                    slot: true,
                }
              ],
              pagination: null,
              showAddUserModal: false,
            }
        },
        watch: {
          queryParams: {
              deep: true,
              handler() {
                  this.loadUserData(this.$route.params.id)
              }
          },
        },
        created() {
            if(this.$route.params.id){
              this.loadData(this.$route.params.id)
              this.loadUserData(this.$route.params.id)
            }
        },
        methods: {
          pageChanged(page) {
              this.queryParams.page = page;
          },
          sorting({column, order}) {
            this.queryParams.sort = column;
            this.queryParams.sort_order = order;
          },
          loadData(groupId){
              this.lyLoading = true;
              this.axios.get('/groups/'+groupId)
              .then((response) => {
                this.group = response.data.data
              })
              .catch(() => {
                  this.showFailMsg("No group exists!");
              })
              .finally(() => {
                  this.lyLoading = false;
              })
          },
          loadUserData(groupId){
            this.queryParams.group_id = groupId
            this.axios.get('/users', {
              params: {...this.queryParams}
            })
            .then((response) => {
              this.users = response.data.data;
              this.pagination = response.data.meta;
            })
            .catch(() => {
                this.showFailMsg("No users exists!");
            })
            .finally(() => {
                this.lyLoading = false;
            })
          },
          removeRecord(id) {
            this.$swal({
                title: 'Are you sure want to remove user from group?',
                text: "You won't be able to revert this!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, remove it!',
                confirmButtonColor: '#dd4b39',
                reverseButtons: true
            }).then((result) => {
                if (result.isConfirmed) {
                    this.axios.post('/remove-user-from-group/'+id).then(() => {
                        this.loadUserData();
                        this.$swal.fire(
                            'Removed',
                            'User has been removed!',
                            'success'
                        )
                    });
                }
            });
          },
          openAddUserModal(){
            this.showAddUserModal = true
          },
          closeAddUserModal(){
            this.loadUserData(this.$route.params.id)
            this.showAddUserModal = false
          }
        }
    }
</script>
<style src="vue-multiselect/dist/vue-multiselect.css"></style>
<style scoped>
.create_item_tab button {
  position: relative;
  float: right;
  right: 0;
  top: 0;
}
.btn_back{
  position: relative;
  float: right;
  right: 0;
  top: 0;
}
.font_italic{
  position: relative;
  display: block;
  left: 120px;
  padding-top: 5px;
}
.multiselect__tags {
  border-radius: 0;
}
</style>
